// extracted by mini-css-extract-plugin
export default {"rating":"hD-z","numberOfStars":"iD-z","count":"jD-z","barGraphSpacing":"kD-z","barGraph":"lD-z"};